// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c5e934c5","backButton":"fa7b318c","title":"e36499d6","lineSpacer":"d791ddf9"};